import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './AdminPagination.css';

type AdminPaginationProps = {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  itemLabel: string;
  onPageChange: (page: number) => void;
};

const AdminPagination: React.FC<AdminPaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  itemLabel,
  onPageChange,
}) => {
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="admin-pagination">
      <p className="admin-pagination-summary">
        Showing <span className="font-semibold text-cyan-400">{startItem}</span>–
        <span className="font-semibold text-cyan-400">{endItem}</span> of{' '}
        <span className="font-semibold">{totalItems}</span> {itemLabel}
      </p>
      <div className="admin-pagination-controls">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="admin-pagination-btn"
          aria-label="Previous page"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="hidden sm:inline">Previous</span>
        </button>
        <span className="admin-pagination-page-info">
          Page <span className="font-semibold text-cyan-400">{currentPage}</span> of{' '}
          <span className="font-semibold">{totalPages}</span>
        </span>
        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="admin-pagination-btn"
          aria-label="Next page"
        >
          <span className="hidden sm:inline">Next</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AdminPagination;
